import React from 'react'
import PropTypes from 'prop-types'

class ShowMore extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = { expanded: false }
  }

  getComputedHeight(props, state) {
    const { lines } = props

    const { height, lineHeight } = this.getElementData()

    const computedHeight = state.expanded ? height : lineHeight * lines

    return computedHeight
  }

  getElementData() {
    if (!this.originalElement) {
      return {}
    }

    const style = window.getComputedStyle(this.originalElement)
    const { height, lineHeight } = style

    const heightNumber = Number(height.replace('px', ''))
    const lineHeightNumber = Number(lineHeight.replace('px', ''))

    return { height: heightNumber, lineHeight: lineHeightNumber }
  }

  static set showMoreButton(showMoreButton) {
    ShowMore.prototype.showMoreButton = showMoreButton
  }

  toggle() {
    const { expanded } = this.state

    this.setState({ expanded: !expanded })
  }

  expandButton() {
    const { lines, showMoreButton } = this.props
    const { expanded } = this.state

    const { height, lineHeight } = this.getElementData()
    const contentIsLong = height > lineHeight * lines

    if (!contentIsLong) {
      return null
    }

    const toggleFunc = this.toggle

    if (typeof showMoreButton === 'function') {
      return showMoreButton({ expanded, toggleFunc })
    }
    if (typeof this.showMoreButton === 'function') {
      return this.showMoreButton({ expanded, toggleFunc })
    }

    return (
      <button onClick={toggleFunc}>
        { expanded ? 'Show less' : 'Show more' }
      </button>
    )
  }

  render() {
    const { children, buttonPosition, className } = this.props

    if (!children) {
      return null
    }

    const computedHeight = this.getComputedHeight(this.props, this.state)

    return (
      <div>
        { buttonPosition === 'top' ? this.expandButton() : '' }
        <div
          style={{
            overflowY: 'hidden',
            transition: 'all ease-in-out 0.3s',
            height: computedHeight || 0,
          }}
          className={className}
        >
          <div ref={ (el) => this.originalElement = el }>
            { children }
          </div>
        </div>
        { buttonPosition === 'bottom' ? this.expandButton() : '' }
      </div>
    )
  }
}

ShowMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number.isRequired,
  showMoreButton: PropTypes.func,
  buttonPosition: PropTypes.string,
  className: PropTypes.string,
}

ShowMore.defaultProps = {
  lines: 3,
  buttonPosition: 'bottom',
}

export default ShowMore
